<template>
  <!-- <div id="app">
    <Header v-if="$route.name !== 'login'"></Header>
    <div class="content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>
  </div> -->
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
#app {
  background-color: #eceef3;
}
.content {
  min-height: calc(100vh - 40px);
}
.bg-grey {
  background-color: #eceef3;
}
.bg-white {
  background-color: #fff;
}
</style>
